import { render, staticRenderFns } from "./StringTable.vue?vue&type=template&id=03bb57ec&scoped=true&"
import script from "./StringTable.vue?vue&type=script&lang=js&"
export * from "./StringTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bb57ec",
  null
  
)

export default component.exports